
import { apiService } from "@services/api.service";
import { ciTrackingService } from "@services/ci-tracking.service";
import { computed, defineComponent, onBeforeMount, ref } from "vue";
import { MetaInfo } from "vue-meta";
import { alternateService } from "@services/alternate.service";
import { Loader, useLoader } from "@composables/loader";

export default defineComponent({
  metaInfo(): MetaInfo {
    const title = this.$t("ui.views.terms.meta_tags.title") as string;
    const description = this.$t("ui.views.terms.meta_tags.description") as string;
    return {
      link: alternateService.fromRoute(this.$route),
      title: title,
      meta: [
        { vmid: "description", name: "description", content: description },
        { vmid: "og:title", property: "og:title", content: title },
        { vmid: "og:description", property: "og:description", content: description },
        { vmid: "twitter:title", name: "twitter:title", content: title },
        { vmid: "twitter:description", name: "twitter:description", content: description },
      ],
    };
  },
  name: "CiTermsAndConditionsPage",
  setup() {
    const content = ref("");
    const loading = computed(() => Loader.loading.state);
    const loader = useLoader();

    const printPage = () => {
      window.print();
    };

    const trackPageView = async () => {
      await ciTrackingService.trackView("TermsAndConditions", "unused");
    };

    onBeforeMount(async () => {
      loader.start();

      try {
        const { data } = await apiService.pages.getTermsAndConditions();
        content.value = data.html;
        trackPageView();
      } catch (error) {
        apiService.handleAPIError(error);
      } finally {
        loader.stop();
      }
    });

    return {
      content,
      loading,
      printPage,
    };
  },
});
